import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Bot, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function AnalisiIA({ from, to, aiStatus, disabled }) {
  const [busy, setBusy] = useState(false);
  const [text, setText] = useState("");
  const run = async () => {
    setBusy(true);
    setText("");
    try {
      const { data } = await api.post("/controllo-ore/analizza", { date_from: from, date_to: to }, { timeout: 120000 });
      setText(data.analisi || "");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "L'assistente non ha risposto");
    } finally {
      setBusy(false);
    }
  };
  if (aiStatus.loaded && !aiStatus.enabled) {
    return <div className="text-xs text-slate-500" data-testid="controllo-ai-disabled">{aiStatus.reason || "Funzioni IA non disponibili per questa azienda"}</div>;
  }
  return (
    <div className="space-y-2">
      <Button type="button" variant="outline" onClick={run} disabled={busy || disabled} data-testid="controllo-ai-btn" className="border-[#0044FF] text-[#0044FF] hover:bg-blue-50">
        {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Bot className="h-4 w-4 mr-2" />}
        Analizza con IA
      </Button>
      {text && (
        <div className="rounded-lg border border-blue-200 bg-blue-50/60 p-3 text-sm whitespace-pre-wrap leading-relaxed" data-testid="controllo-ai-text">{text}</div>
      )}
    </div>
  );
}
